import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

interface Props {
  isActive: boolean;
  onClick(): void;
}

export const Tab = ({
  isActive,
  onClick,
  children,
}: PropsWithChildren<Props>) => (
  <button
    className={clsx("py-2 px-3 border-b-2 hover:text-cosmic+1", {
      "border-b-white": !isActive,
      "border-b-cosmic+1": isActive,
    })}
    onClick={onClick}
  >
    {children}
  </button>
);
